import React, { useEffect } from 'react';
import styled from 'styled-components';
import { BodyMixin } from '@qover/typography';
import { SecondaryButton } from '@qover/molecules';

export const UpsellContainer = styled.div`
  ${BodyMixin};
  align-items: center;
  background-color: var(--color-text-quote-05);
  display: flex;
  flex-direction: column;
  line-height: normal;
  margin: 20px 0;
  padding: 20px;

  > * + * {
    margin-top: 10px;
  }

  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    flex-direction: row;
    justify-content: space-between;

    > * + * {
      margin-left: 20px;
      margin-top: 0;
    }
    button {
      margin-left: 60px;
    }
  }
`;

type SummaryUpsell = {
  buttonText: React.ReactNode;
  message: React.ReactNode;
  onClick: React.DOMAttributes<HTMLButtonElement>['onClick'];
  onView: () => void;
};

export function SummaryUpsell(props: any) {
  useEffect(() => {
    if (props.onView) {
      props.onView();
    }
  }, []);

  return (
    <UpsellContainer>
      <span>{props.message}</span>
      <SecondaryButton type="button" onClick={props.onClick}>
        {props.buttonText}
      </SecondaryButton>
    </UpsellContainer>
  );
}
